// extracted by mini-css-extract-plugin
module.exports = {"container":"container--APYB6","tabGroup":"tabGroup--V4iXj"};